import { INTEGRATION_ENUM } from "../../constants/constants";

// export const buildAuthorMap = (messages = []) => {
//   const map = {};
//   messages.forEach((msg) => {
//     const channels =
//       msg.integrationSettingId?.defaultSettings?.find(
//         (s) => s.name === "channels",
//       )?.data || [];
//     channels.forEach((ch) => {
//       (ch.members || []).forEach((m) => {
//         if (m.userId && !map[m.userId]) {
//           map[m.userId] = m.name;
//         }
//       });
//     });
//   });
//   return map;
// };

// export function groupMessagesByParticipant(
//   messages = [],
//   participantUsernameMap = {},
//   authorMap = {},
// ) {
//   const integrationGroups = new Map();

//   messages.forEach((msg) => {
//     const integrationKey = String(
//       msg.integrationSettingId?.uuid ||
//         msg.integrationSettingId ||
//         msg.platform ||
//         "unknown",
//     );

//     if (!integrationGroups.has(integrationKey)) {
//       integrationGroups.set(integrationKey, {
//         integrationKey,
//         integrationLabel: capitalize(msg.platform || integrationKey),
//         participants: new Map(),
//       });
//     }
//     const integrationGroup = integrationGroups.get(integrationKey);

//     const platform = String(msg.platform || "").toLowerCase();
//     const groupByThread = ALL_CONVERSATION_INTEGRATIONS.includes(platform);
//     const displayName = groupByThread
//       ? resolveConversationListName(msg, { platform }, authorMap)
//       : resolveAuthor(msg.author?.name, authorMap);

//     const authorIdentity =
//       msg.author?.uuid || msg.author?._id || msg.author || displayName;

//     const participantKey = groupByThread
//       ? msg.externalThreadId || msg.uuid
//       : participantUsernameMap[authorIdentity] || authorIdentity;

//     if (!integrationGroup.participants.has(participantKey)) {
//       integrationGroup.participants.set(participantKey, {
//         participantKey,
//         displayName,
//         messages: [],
//       });
//     }

//     integrationGroup.participants.get(participantKey).messages.push(msg);
//   });
// console.log('integrationGroups :>> ', integrationGroups);
//   return Array.from(integrationGroups.values()).map((group) => ({
//     integrationKey: group.integrationKey,
//     integrationLabel: group.integrationLabel,
//     participants: Array.from(group.participants.values())
//       .map((participants) => ({
//         ...participants,
//         messages: [...participants.messages].sort(
//           (a, b) => new Date(b.sentAt || 0) - new Date(a.sentAt || 0),
//         ),
//       }))
//       .sort((a, b) => b.messages.length - a.messages.length),
//   }));
// }

// export const buildParticipantUsernameMap = (
//   messages = [],
//   participants = [],
// ) => {
//   const map = {};

//   const getSettingId = (message) =>
//     message?.integrationSettingId?.uuid || message?.integrationSettingId;
//   const belongsToMessageSource = (participant, message) => {
//     const settingId = getSettingId(message);
//     const platform = String(message?.platform || "").toLowerCase();

//     if (settingId && participant?.integrationSettingIds?.length) {
//       return participant.integrationSettingIds.includes(settingId);
//     }

//     return !platform || participant?.integrations?.includes(platform);
//   };
//   const findParticipantUsername = (value, message) => {
//     if (!value) return null;

//     return participants.find(
//       (participant) =>
//         String(participant?.username || "").toLowerCase() ===
//           String(value).toLowerCase() &&
//         belongsToMessageSource(participant, message),
//     )?.username;
//   };
//   const addDirectMatch = (item, message) => {
//     const username = findParticipantUsername(item?.author, message);
//     if (item?.author && username) map[item.author] = username;
//   };

//   messages.forEach((message) => {
//     addDirectMatch(message, message);
//     (message?.threads || []).forEach((thread) =>
//       addDirectMatch(thread, message),
//     );
//     (message?.messages || []).forEach((item) => addDirectMatch(item, message));

//     const channels =
//       message.integrationSettingId?.defaultSettings?.find(
//         (setting) => setting.name === "channels",
//       )?.data || [];

//     channels.forEach((channel) => {
//       (channel.members || []).forEach((member) => {
//         const username = findParticipantUsername(member?.username, message);
//         if (member?.userId && username) map[member.userId] = username;
//       });
//     });
//   });
// console.log('map :>> ', map);
//   return map;
// };

export const resolveAuthor = (author, authorMap = {}) => {
  if (author && typeof author === "object") {
    return (
      author.name ||
      author.displayName ||
      author.username ||
      author.uuid ||
      "Unknown"
    );
  }

  const authorId = String(author || "");
  if (authorId.toLowerCase() === "bot") return "Bot";
  if (!authorId) return "Unknown";
  if (authorMap[authorId]) return authorMap[authorId];
  return authorId.length > 12 ? authorId.slice(0, 8) + "…" : authorId;
};

const isPageAuthor = (author, message) => {
  const ownExternalUserId = message?.integrationSettingId?.externalUserId;
  const authorExternalUserId = author?.externalUserId;

  if (!ownExternalUserId || !authorExternalUserId) return null; // unknown, can't decide
  return authorExternalUserId === ownExternalUserId;
};

const isLikelyPageAuthorFallback = (item, ownerId, ownerName) => {
  const name = resolveAuthor(item?.author?.name, {});
  const normalizedName = name.toLowerCase();

  return (
    name === "Unknown" ||
    normalizedName === ownerName ||
    ["messenger", "instagram"].includes(normalizedName) ||
    item?.author?.uuid === ownerId ||
    item?.author === ownerId
  );
};

const findCustomerMessage = (message, authorMap) => {
  const ownerId = message?.author?.uuid || message?.author;
  const ownerName = resolveAuthor(
    message?.author?.name,
    authorMap,
  ).toLowerCase();
  const candidates = [
    message,
    ...(message?.messages || []),
    ...(message?.threads || []),
  ];

  const haveExternalUserIds = Boolean(
    message?.integrationSettingId?.externalUserId &&
    candidates.some((item) => item?.author?.externalUserId),
  );

  return candidates.find((item) => {
    if (!item?.author) return false;

    if (haveExternalUserIds) {
      const isPage = isPageAuthor(item.author, message);
      return isPage === false;
    }

    return !isLikelyPageAuthorFallback(item, ownerId, ownerName);
  });
};

const getOtherConversationParticipant = (message, authorMap) => {
  const customerMessage = findCustomerMessage(message, authorMap);
  return customerMessage
    ? resolveAuthor(customerMessage.author?.name, authorMap)
    : null;
};

const getOtherConversationMessage = (message, authorMap) =>
  findCustomerMessage(message, authorMap);

export const resolveConversationListName = (message, group, authorMap = {}) => {
  const platform = String(
    message?.platform || group?.platform || "",
  ).toLowerCase();
  const isMetaConversation = [
    INTEGRATION_ENUM.INSTAGRAM_MESSAGES,
    INTEGRATION_ENUM.FACEBOOK_MESSAGES,
  ].includes(platform);

  if (isMetaConversation) {
    return (
      getOtherConversationParticipant(message, authorMap) ||
      resolveAuthor(message?.author?.name, authorMap)
    );
  }

  return resolveAuthor(message?.author?.name, authorMap);
};

export const resolveConversationListUsername = (
  message,
  group,
  participantUsernameMap = {},
  authorMap = {},
) => {
  const platform = String(
    message?.platform || group?.platform || "",
  ).toLowerCase();
  const resolveUsername = (item) =>
    participantUsernameMap[item?.author] ||
    resolveAuthor(item?.author?.name, authorMap);

  if (
    [
      INTEGRATION_ENUM.INSTAGRAM_MESSAGES,
      INTEGRATION_ENUM.FACEBOOK_MESSAGES,
    ].includes(platform)
  ) {
    return resolveUsername(
      getOtherConversationMessage(message, authorMap) || message,
    );
  }

  return resolveUsername(message);
};

export const resolveMentions = (text = "", authorMap = {}) => {
  return text.replace(/<@([A-Z0-9a-z_-]+)>/g, (match, userId) => {
    return authorMap[userId] ? `@${authorMap[userId]}` : match;
  });
};

function formatDateLabel(dateKey) {
  if (dateKey === "no-date") return "Undated";

  const date = new Date(dateKey);
  date.setHours(0, 0, 0, 0);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  if (date.getTime() === today.getTime()) return "Today";
  if (date.getTime() === yesterday.getTime()) return "Yesterday";

  return date.toLocaleDateString(undefined, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function formatTime(sentAt) {
  if (!sentAt) return "";
  return new Date(sentAt).toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });
}

export function groupMessagesByDate(messages) {
  const groups = {};

  messages.forEach((msg) => {
    const dateKey = msg.sentAt
      ? new Date(msg.sentAt).toDateString()
      : "no-date";
    if (!groups[dateKey]) groups[dateKey] = [];
    groups[dateKey].push(msg);
  });

  return Object.entries(groups)
    .map(([dateKey, msgs]) => ({
      dateKey,
      label: formatDateLabel(dateKey),
      messages: [...msgs].sort(
        (a, b) => new Date(b.sentAt || 0) - new Date(a.sentAt || 0),
      ),
    }))
    .sort((a, b) => {
      if (a.dateKey === "no-date") return 1;
      if (b.dateKey === "no-date") return -1;
      return new Date(b.dateKey) - new Date(a.dateKey);
    });
}

export function groupMessagesByDateChronologically(messages) {
  return groupMessagesByDate(messages).map((group) => ({
    ...group,
    messages: [...group.messages].reverse(),
  }));
}

export const getMessageId = (item) =>
  item?.uuid || item?._id || item?.externalMessageId || item?.externalThreadId;

export const ALL_CONVERSATION_INTEGRATIONS = [
  INTEGRATION_ENUM.INSTAGRAM_MESSAGES,
  INTEGRATION_ENUM.FACEBOOK_MESSAGES,
  INTEGRATION_ENUM.TWILIO,
  INTEGRATION_ENUM.CRISP,
  INTEGRATION_ENUM.INTERCOM,
];

export const THREAD_REPLY_PLATFORMS = [
  INTEGRATION_ENUM.DISCORD,
  INTEGRATION_ENUM.WHATSAPP,
  INTEGRATION_ENUM.GMAIL,
  INTEGRATION_ENUM.OUTLOOK,
  INTEGRATION_ENUM.INSTAGRAM_MESSAGES,
  INTEGRATION_ENUM.FACEBOOK_MESSAGES,
  INTEGRATION_ENUM.CRISP,
];

export const COMMENT_PLATFORMS = [
  INTEGRATION_ENUM.INSTAGRAM_COMMENTS,
  INTEGRATION_ENUM.FACEBOOK_COMMENTS,
];

export const NO_NEW_MESSAGE_PLATFORMS = [
  INTEGRATION_ENUM.CRISP,
  INTEGRATION_ENUM.GMAIL,
  INTEGRATION_ENUM.OUTLOOK,
  INTEGRATION_ENUM.INSTAGRAM_COMMENTS,
  INTEGRATION_ENUM.FACEBOOK_COMMENTS,
  INTEGRATION_ENUM.FACEBOOK_READONLY_MESSAGES,
  INTEGRATION_ENUM.INSTAGRAM_READONLY_MESSAGES,
];
